import { Provider } from '@angular/core'

import { whenMainThreadSettles } from '@ti/core/common/utils'
import { BaseConfig, CONFIG } from '@ti/core/contracts/config'
import { FIREBASE_APP } from '@ti/core/contracts/firebase'

export const provideFirebaseApp = (): Provider[] => {
  return [
    {
      provide: FIREBASE_APP,
      useFactory: (config: BaseConfig) => {
        if (!config.firebase) {
          return Promise.resolve(undefined)
        }

        return import('firebase/app').then(async (m) => {
          const { initializeApp } = m
          const firebaseApp = initializeApp(config.firebase!)

          // Analytics injects the Google tag, which costs ~100 ms of main thread
          whenMainThreadSettles()
            .then(() => import('firebase/analytics'))
            .then(async (analyticsModule) => {
              if (await analyticsModule.isSupported()) {
                analyticsModule.getAnalytics(firebaseApp)
              }
            })
            .catch((err) => console.error('Firebase Analytics error', err))

          return firebaseApp
        })
      },
      deps: [CONFIG],
    },
  ]
}
